export default __webpack_public_path__ + "static/media/banner05.1c9d6ca7.png";